import { createSlice } from '@reduxjs/toolkit';
import revisionsEndpoints from 'app/api/services/revisionsEndpoints';
import { errorHandler } from 'app/utils/errorHandler';

const initialState = {
  revisions: {},
  details: {},
  deadLine: 0,
};

const revisionsSlice = createSlice({
  name: 'revisions',
  initialState,
  reducers: {
    setRevisions(state, action) {
      state.revisions = action.payload;
    },
    clearRevisions(state, action) {
      state.revisions = initialState.revisions;
    },
    setActualRevision(state, action) {
      state.details = action.payload;
    },
    clearActualRevision(state, action) {
      state.revisions = initialState.details;
    },
    setDeadLine(state, action) {
      state.deadLine = action.payload;
    },
  },
});

export const fecthAllRevisions = (cdSolicitacao, context) => async dispatch => {
  try {
    let response = {};
    response = await revisionsEndpoints.getRevisions(cdSolicitacao, context);
    dispatch(setRevisions(response.data));    
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fecthActualRevision = (cdSolicitacao, context) => async dispatch => {
  try {
    let response = [];
    response = await revisionsEndpoints.getActualRevision(cdSolicitacao, context);
    dispatch(setActualRevision(response.data));    
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchDeadLine = () => async dispatch => {
  try {
    let response = [];
    response = await revisionsEndpoints.getDaysToDeadLine();
    dispatch(setDeadLine(response.data));    
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const {
  setRevisions,
  clearRevisions,
  setActualRevision,
  clearActualRevision,
  setDeadLine,
} = revisionsSlice.actions;
export default revisionsSlice;
